var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowAviso)?_c('div',{attrs:{"id":"aviso-selecionar-territorio"}},[_c('el-alert',{attrs:{"title":_vm.$t('mensagens.laudos.avisoPadrao'),"type":"warning","show-icon":"","close-text":"","closable":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }